
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"opacity":".2","width":"24","height":"24","rx":"4","fill":"#4FAEAF"}}),_c('path',{attrs:{"d":"M15.333 18.167H8.667c-2.434 0-3.834-1.4-3.834-3.833V9.667c0-2.433 1.4-3.833 3.834-3.833h6.666c2.434 0 3.834 1.4 3.834 3.833v4.667c0 2.433-1.4 3.833-3.834 3.833zM8.667 6.834c-1.907 0-2.834.927-2.834 2.833v4.667c0 1.907.927 2.833 2.834 2.833h6.666c1.907 0 2.834-.926 2.834-2.833V9.667c0-1.906-.927-2.833-2.834-2.833H8.667z","fill":"#4FAEAF"}}),_c('path',{attrs:{"d":"M12 12.58c-.56 0-1.127-.173-1.56-.527l-2.087-1.666a.498.498 0 01.62-.78l2.087 1.666c.506.407 1.367.407 1.873 0l2.087-1.666a.492.492 0 01.7.08.492.492 0 01-.08.7l-2.087 1.666c-.427.354-.993.527-1.553.527z","fill":"#4FAEAF"}})])
          )
        }
      }
    